/**
 * Ring Size Chart Manager
 * Handles interactions for the static HTML size chart (table view only)
 */
class RingSizeChart {
  constructor(container) {
    this.container = container;
    this.currentRegion = 'US';
    this.currentUnit = 'mm';
    
    this.init();
  }

  init() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Unit toggle buttons
    const unitButtons = this.container.querySelectorAll('[data-unit]');
    unitButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const unit = e.target.getAttribute('data-unit');
        if (unit !== this.currentUnit) {
          this.currentUnit = unit;
          this.updateUnits();
        }
      });
    });

    // Region selector
    const regionSelect = this.container.querySelector('[data-region-select]');
    if (regionSelect) {
      regionSelect.addEventListener('change', (e) => {
        this.currentRegion = e.target.value;
        this.updateRegion();
      });
    }
  }

  updateUnits() {
    // Update unit toggle buttons
    const unitButtons = this.container.querySelectorAll('[data-unit]');
    unitButtons.forEach(btn => {
      btn.classList.remove('active');
      if (btn.getAttribute('data-unit') === this.currentUnit) {
        btn.classList.add('active');
      }
    });

    // Update unit label
    const unitLabel = this.container.querySelector('[data-unit-label]');
    if (unitLabel) {
      unitLabel.textContent = this.currentUnit === 'mm' ? 'MM' : 'INCH';
    }

    // Update all measurement displays
    const measurements = this.container.querySelectorAll('.size-chart-measurement');
    measurements.forEach(measurement => {
      const mmValue = measurement.getAttribute('data-mm');
      const inchValue = measurement.getAttribute('data-inch');
      
      if (this.currentUnit === 'mm') {
        measurement.textContent = mmValue;
      } else {
        measurement.textContent = inchValue;
      }
    });
  }

  updateRegion() {
    // Update region label
    const regionLabel = this.container.querySelector('[data-current-region]');
    if (regionLabel) {
      regionLabel.textContent = this.currentRegion;
    }

    // Hide all rows
    const allRows = this.container.querySelectorAll('.size-chart-row');
    allRows.forEach(row => {
      row.style.display = 'none';
    });

    // Show rows for current region
    const currentRegionRows = this.container.querySelectorAll(`[data-region="${this.currentRegion}"]`);
    currentRegionRows.forEach(row => {
      row.style.display = 'flex';
    });
  }
}

// Export for use in other files
if (typeof window !== 'undefined') {
  window.RingSizeChart = RingSizeChart;
}

// Export for use in other files
if (typeof window !== 'undefined') {
  window.RingSizeChart = RingSizeChart;
  window.RING_SIZE_DATA = RING_SIZE_DATA;
}